import { FC } from 'react';
import { useTranslation } from 'next-i18next';
import getSnoozeStatus from 'src/common/utils/getSnoozeStatus';
import { formatDateForDisplay } from 'src/common/utils/dateHelpers';
import getFormattedDates from 'src/admin/listing-editor/utils/getFormattedDates';
import useDateFnsLocale from 'src/common/hooks/useDateFnsLocale';
import styles from './ListingCard.module.scss';

type Props = {
  active: boolean;
  snoozeStartDate: string | null;
  snoozeEndDate: string | null;
};

const SnoozeDates: FC<Props> = ({
  active,
  snoozeStartDate,
  snoozeEndDate,
}) => {
  const locale = useDateFnsLocale();
  const [t] = useTranslation('admin-listings');
  if (!active || !snoozeStartDate || !snoozeEndDate) return null;
  const { snoozeActive, snoozeScheduled } = getSnoozeStatus(snoozeStartDate, snoozeEndDate);

  const startDate = formatDateForDisplay(snoozeStartDate, false, locale);
  const formattedSnoozeDates = getFormattedDates(snoozeStartDate, snoozeEndDate, locale);

  const getTitle = () => {
    if (snoozeActive) return t('landing-page--snooze-active', { dates: formattedSnoozeDates });
    if (snoozeScheduled) return t('landing-page--snooze-scheduled', { startDate });
    return '';
  };

  return (
    <div className={styles.snoozeStatus}>
      {getTitle()}
    </div>
  );
};

export default SnoozeDates;
